import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service'

@Component({
  selector: 'app-coment-no-labora',
  templateUrl: './coment-no-labora.component.html',
  styleUrls: ['./coment-no-labora.component.scss'],
})
export class ComentNoLaboraComponent implements OnInit {
  
  constructor(public api: ApiService) {}
  @ViewChild('inputFechaA') input1: ElementRef;
  @ViewChild('inputUltLlamada') input2: ElementRef;

  ngOnInit() { console.log(this.api.acuerdoNoLabora); console.log(this.api.numSolNoLabora); console.log(this.api.fechaNoLabora); }

  ionViewWillEnter() {
    this.input1.nativeElement.value = this.api.fechaNoLabora;
    this.input2.nativeElement.value = this.api.fechaUltLlamada;
  }

  cambiarEstado(dato) {
    if(dato){
      this.api.acuerdoNoLabora = true;
    } else {
      this.api.acuerdoNoLabora = false;
    }
  }

}
